__turbopack_context__.v({
  "card": "ContentWithSidebar-module__WfYwAq__card",
  "cardBlue": "ContentWithSidebar-module__WfYwAq__cardBlue",
  "cardOrange": "ContentWithSidebar-module__WfYwAq__cardOrange",
  "cardTitle": "ContentWithSidebar-module__WfYwAq__cardTitle",
  "layout": "ContentWithSidebar-module__WfYwAq__layout",
  "main": "ContentWithSidebar-module__WfYwAq__main",
  "sidebar": "ContentWithSidebar-module__WfYwAq__sidebar",
});
